import { TranslationService } from '@core-services';

export function translationFactory(translationService: TranslationService) {
  return (): void => translationService.init();
}
